module.exports = __webpack_public_path__ + "img/180.9f5c335a.jpg";